import React from "react";
import "../../css/featured.css";
import ExploreMore from "../../ExploreMore";
import Navbar from "../../Navbar";
export const Unitedpassenger = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            heading
          </h1>
          {/* <div className="article-category">
            Canada's 10 Most Influential Women Leaders to Watch in 2024
          </div> */}
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/united-passenger.jpg"
              alt="Professional woman at desk"
              className="article-image"
            />
            {/* <div className="article-image-caption">
            
            </div> */}
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>News content</p>
          </div>
        </div>
      </div>
      <ExploreMore />
    </>
  );
};
